<template>
  <div
    id="app"
  >
    <template v-if="loading">
      <Loading/>
    </template>
    <Sidebar></Sidebar>
    <Main></Main>
    <div class="error" v-if="hasError">
      {{ $t('editorSessionExpired') }}
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { uuid } from 'vue-uuid';
  import axios from 'axios';
  import Sidebar from '@/components/Setup/Sidebar.vue';
  import Main from '@/components/Setup/Main.vue';
  import Loading from '@/components/Global/Loading.vue';
  import { setRepositoryUrl } from './repositories/repository.js'
  import { RepositoryFactory } from './repositories/repositoryFactory.js';
  import { messenger, handlers as messengerHandlers } from '../src/js/messenger.js';
  import { migarateToLatest } from '../src/js/migrator.js';
  
  const SessionRepository = RepositoryFactory.get('session');
  const FormatRepository = RepositoryFactory.get('formats');
  const ProjectRepository = RepositoryFactory.get('projects');
  const PlaceholderRepository = RepositoryFactory.get('placeholders');

  export default {
    name: 'app',
    data() {
      return {
        loading: false,
        hasError: false
      }
    },
    computed: {
      ...mapGetters([
          'getSessionToken',
          'getSessionDetails'
      ]),
      colors() {
        return {
            '--primary-color': `#${this.getSessionDetails.editorSetup.colors.primaryColor}`
        }
      }
    },
    methods: {
      async localToken(token) {
        const headers = {
          'api-key' : 'session',
          'api-sign' : token
        }
        try {
          // const url = "https://editor.aws.key2print.com/api/v1";
          // const url = "https://backend.editor.aws.key2print.com/api/v1";
          
          setRepositoryUrl(url);
          const sessionDetailsResponse = await SessionRepository.sessionDetails(headers);
          const sessionDetails = sessionDetailsResponse.data.data;

          console.log(sessionDetails)

          const payload = {
            token,
            backendUrl: url,
            mode: sessionDetails.mode,
            editorSetup: Object.keys(sessionDetails).includes('editorSetup') ? sessionDetails.editorSetup : null,
            placeholderValues: Object.keys(sessionDetails).includes('placeholderValues') ? sessionDetails.placeholderValues : null,
            productGatewayEnabled: Object.keys(sessionDetails).includes('productGatewayEnabled') ? sessionDetails.productGatewayEnabled : null,
            customFonts: sessionDetails.fonts
          };

          this.$store.dispatch('ADD_SESSION_DETAILS', payload);
          this.$store.dispatch('ADD_SESSION_TOKEN', payload);

          const listPlaceholders = await PlaceholderRepository.getPlaceholders(headers);
          const placeholders = listPlaceholders.data.data.entities;

          this.$store.dispatch('SET_PLACEHOLDERS', placeholders);

          if (this.getSessionDetails.mode === 'merchant') {
            this.$router.push({ name: 'templates' });
          }

          if (this.getSessionDetails.mode === 'user') {

            const templateData = {
              id: sessionDetails.project.templateFormat.id,
              name: sessionDetails.project.templateFormat.name,
              pageWidth: sessionDetails.project.templateFormat.pageWidth,
              pageHeight: sessionDetails.project.templateFormat.pageHeight,
              pageBleed: sessionDetails.project.templateFormat.pageBleed
            }

            this.$store.dispatch('ADD_TEMPLATE_DATA', templateData);

            let projectData = {
              id: sessionDetails.project.id,
              name: sessionDetails.project.name,
              templateFormatId: templateData.id
            }

            // console.log('project pages: ', sessionDetails.project.pages)

            if (sessionDetails.project.pages.length < 1) {
              const newPageId = uuid.v1();

              const pageData = {
                html: null,
                content: {
                  id: newPageId,
                  zIndex: 0,
                  isActive: true,
                  elements: [],
                  pageColor: {
                    rgb: 'rgb(255, 255, 255)',
                    hex: 'FFFFFF',
                    X: 0,
                    Y: 150
                  },
                  pageRadius: 0,
                  isLocked: false,
                  version: 1.0,
                  backgroundImage: {
                    url: null,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                  }
                }
              };

              projectData.pages = [pageData];

            } else {
              const projectDataResponse = await ProjectRepository.getProject(sessionDetails.project.id, headers);
              // console.log('res: ', projectDataResponse)
              const promises = projectDataResponse.data.data.pages.map(page => {
                return ProjectRepository.getProjectPage(sessionDetails.project.id, page.number, headers);
              });


              // console.log(promises)
              let pageData = (await Promise.all(promises)).map((page, index) => {
                // console.log(page)
                const content = page.data.data.content !== null ? page.data.data.content : {}
                const pageContent = migarateToLatest(content);

                // console.log('pagecontent: ', pageContent)

                return {
                  ...page.data.data,
                  content: {
                      ...pageContent,
                      elements: []
                  }
                }
              }).sort((a, b) => parseFloat(a.number) - parseFloat(b.number));

              let pageDataMapped = pageData.map((page, index) => {
                const pageContent = page.content;
                const isActive = index === 0 ? true : false;
                // const id = page.content.id !== undefined ? page.content.id : uuid.v1();

                // console.log(isActive)

                return {
                  ...page,
                  content: {
                    ...pageContent,
                    isActive
                  }
                }
              })

              projectData.pages = pageDataMapped;
            }

            // console.log('projectdata: ', projectData)

            const activeFormatThemeTab = {
                id: templateData.id,
                name: templateData.name,
                width: templateData.pageWidth,
                height: templateData.pageHeight
            }
            this.$store.dispatch('SET_ACTIVE_FORMAT_IN_THEME_TAB', activeFormatThemeTab);
            this.$store.dispatch('SET_ACTIVE_PROJECT_IN_THEME_TAB', projectData.id);

            this.$store.dispatch('ADD_PROJECT_DATA', projectData).then(() => {
                this.$router.push({ name: 'editProject', params: { projectName: projectData.name } })
            });
          }
        }

        catch(err) {
          this.hasError = true;
        }
      }
    },
    async created() {

      // this.localToken('JDJ5JDEwJHJvSFc0QmYxbEZXSmpKbjVLdHNUaE9lbWthbFVxNkM2YXRwMUZNcC5IZE9DVXIuNTJvV0dH');

      //user

      // this.localToken('JDJ5JDEwJFd0RjhPaVFWcGMzSU1XblBzbTBpZk95eG05ZGMxNkY1bzc0UjBaZ3U3R0VhcGU3ZEVqV0Rh');

      //for production

        
        try {
          messenger.begin();
      
          let {token, backendUrl} = await new Promise(resolve => {
            messengerHandlers.tokenReceivedHandler = resolve;
          });

          setRepositoryUrl(backendUrl);

          const headers = {
            'api-key' : 'session',
            'api-sign' : token
          }
          const sessionDetailsResponse = await SessionRepository.sessionDetails(headers);
          const sessionDetails = sessionDetailsResponse.data.data;

          console.log(sessionDetails)

          const payload = {
            token,
            backendUrl,
            mode: sessionDetails.mode,
            editorSetup: Object.keys(sessionDetails).includes('editorSetup') ? sessionDetails.editorSetup : null,
            placeholderValues: Object.keys(sessionDetails).includes('placeholderValues') ? sessionDetails.placeholderValues : null,
            productGatewayEnabled: Object.keys(sessionDetails).includes('productGatewayEnabled') ? sessionDetails.productGatewayEnabled : null,
            customFonts: sessionDetails.fonts
          };

          this.$store.dispatch('ADD_SESSION_DETAILS', payload);
          this.$store.dispatch('ADD_SESSION_TOKEN', payload);
        const listPlaceholders = await PlaceholderRepository.getPlaceholders(headers);
        const placeholders = listPlaceholders.data.data.entities;

        this.$store.dispatch('SET_PLACEHOLDERS', placeholders);


          if (this.getSessionDetails.mode === 'merchant') {
            this.$router.replace({ name: 'templates' });
          }

          if (this.getSessionDetails.mode === 'user') {
            const templateData = {
              id: sessionDetails.project.templateFormat.id,
              name: sessionDetails.project.templateFormat.name,
              pageWidth: sessionDetails.project.templateFormat.pageWidth,
              pageHeight: sessionDetails.project.templateFormat.pageHeight,
              pageBleed: sessionDetails.project.templateFormat.pageBleed
            }

            this.$store.dispatch('ADD_TEMPLATE_DATA', templateData);

            let projectData = {
              id: sessionDetails.project.id,
              name: sessionDetails.project.name,
              templateFormatId: templateData.id
            }

            if (sessionDetails.project.pages.length < 1) {
              const newPageId = uuid.v1();

              const pageData = {
                html: null,
                content: {
                  id: newPageId,
                  zIndex: 0,
                  isActive: true,
                  elements: [],
                  pageColor: {
                    rgb: 'rgb(255, 255, 255)',
                    hex: 'FFFFFF',
                    X: 0,
                    Y: 150
                  },
                  pageRadius: 0,
                  isLocked: false,
                  version: 1.0,
                  backgroundImage: {
                    url: null,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                  }
                }
              };

              projectData.pages = [pageData];

            } else {
              const projectDataResponse = await ProjectRepository.getProject(sessionDetails.project.id, headers);
              const promises = projectDataResponse.data.data.pages.map(page => {
                return ProjectRepository.getProjectPage(sessionDetails.project.id, page.number, headers);
              });

              let pageData = (await Promise.all(promises)).map((page, index) => {
                const content = page.data.data.content !== null ? page.data.data.content : {}
                const pageContent = migarateToLatest(content);

                return {
                  ...page.data.data,
                  content: {
                      ...pageContent,
                      elements: []
                  }
                }
              }).sort((a, b) => parseFloat(a.number) - parseFloat(b.number));

              let pageDataMapped = pageData.map((page, index) => {
                const pageContent = page.content;
                const isActive = index === 0 ? true : false;

                return {
                  ...page,
                  content: {
                    ...pageContent,
                    isActive
                  }
                }
              });

              projectData.pages = pageDataMapped;

              const activePageId = projectData.pages.find(page => page.content.isActive === true).content.id; 
            }

            const activeFormatThemeTab = {
                id: templateData.id,
                name: templateData.name,
                width: templateData.pageWidth,
                height: templateData.pageHeight
            }
            this.$store.dispatch('SET_ACTIVE_FORMAT_IN_THEME_TAB', activeFormatThemeTab);
            this.$store.dispatch('SET_ACTIVE_PROJECT_IN_THEME_TAB', projectData.id);

            this.$store.dispatch('ADD_PROJECT_DATA', projectData).then(() => {
                this.$router.replace({ name: 'editProject', params: { projectName: projectData.name } })
            });
          }
        }

        catch(err) {
          this.hasError = true;
        }
    },
    components: {
      Sidebar,
      Main,
      Loading
    }
  }
</script>

<style lang="scss">
  @import 'styles/global.scss';

  #app {
    height: 100%;
    display: flex;
  }
  .error {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
  }
</style>
